/**
 * Utility functions for Guesty Message History
 */

// Format date time string to local format
export const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return 'N/A';
    
    const date = new Date(dateTimeString);
    return date.toLocaleString();
};

// Helper function to format ISO date strings to local time
export const formatISOToLocalDateTime = (isoString) => {
    if (!isoString) return 'N/A';
    try {
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return isoString; // Return original if invalid date
        return date.toLocaleString(); // Format to local date and time
    } catch (e) {
        return isoString; // Return original on error
    }
};

// Table styles configuration
export const customStyles = {
    rows: {
        style: {
            minHeight: '40px',
        },
    },
    headCells: {
        style: {
            fontWeight: 'bold',
            fontSize: '0.9rem',
            backgroundColor: '#f8f9fa',
            paddingTop: '12px',
            paddingBottom: '12px',
        },
    },
    cells: {
        style: {
            paddingTop: '8px',
            paddingBottom: '8px',
        },
    },
};
